/**
 * ehr#758: a Referral source of "Other" needs its "Please specify..." box filled. Save record
 * refuses it blank (red box, listed with the other required fields); Save draft still saves. The
 * chart's Referral section and the Add client window share these rules.
 */

/** The choice that opens the write-in box (the chart's select shows the box for exactly this). */
export const REFERRAL_OTHER = 'Other';

/** True when the picked referral source is "Other". */
export function isOtherReferral(source: string | null | undefined): boolean {
  return (source ?? '').trim() === REFERRAL_OTHER;
}

/** The Referral section's blank "Please specify" box on Save record, as a missing-field entry. */
export function referralOtherMissing(
  referral: Record<string, string> | undefined,
  draft: boolean,
): { sec: string; field: string; label: string }[] {
  if (draft || !isOtherReferral(referral?.referralSource)) return [];
  if ((referral?.referralSourceOther ?? '').trim()) return [];
  return [
    { sec: 'referral', field: 'referralSourceOther', label: 'Referral source (please specify)' },
  ];
}

/** The Add client window: "Other" picked as the referral source with nothing typed to explain it. */
export function newClientReferralOtherMissing(
  sourceName: string | undefined,
  specify: string | undefined,
): boolean {
  return isOtherReferral(sourceName) && !(specify ?? '').trim();
}

/** The required write-in's hint, so the box says it must be filled before anyone saves. */
export const REFERRAL_SPECIFY_PLACEHOLDER = 'Please specify (required)';

/** True for the chart's Referral source write-in (the only "Please specify" box that is required). */
export function isReferralSpecifyBox(sec: string, otherKey: string | undefined): boolean {
  return sec === 'referral' && otherKey === 'referralSourceOther';
}

/**
 * The write-in shows red right away while it is blank (not only after a refused Save record), so
 * people see it must be filled in.
 */
export function referralSpecifyRed(
  sec: string,
  otherKey: string | undefined,
  text: string | undefined,
): boolean {
  return isReferralSpecifyBox(sec, otherKey) && !(text ?? '').trim();
}
